<template>
    <div>
        <div class="content">
            <div class="flex-center-y center">
                <img :src="productImage"/>
                <div class="name">
                    <div>{{device.deviceName}}</div>
                    <div>{{device.device.installLocation}}</div>
                </div>
            </div>
        </div>
        <Divider :style="{ color: '#aaaaaa61', borderColor: '#aaaaaa61' }"/>
        <Form @submit="submit">
            <Field
                    v-model="handleMethodName"
                    label="处理方式"
                    required
                    readonly
                    clearable
                    @click="updateShow"
                    placeholder="请选择处理方式"
                    right-icon="arrow-down"
                    :rule="[{required:true,message:'请选择处理方式'}]"
            />
            <Field
                    v-model="detail.handleRemark"
                    label="处理意见"
                    clearable
                    required
                    placeholder="请输入处理意见"
                    :rule="[{required:true,message:'请输入处理意见'}]"
            />
            <div style="display:flex;justify-content : space-between;width:75%;margin:auto;">
                <UploadImage
                        :imageList="image1"
                        style="margin-top:5px;margin-left:-15px"
                        top="照片1"
                        type="WorkOrderImage"
                        @imageChange="image1Change"
                        :count="1"
                        edit
                />
                <UploadImage
                        :imageList="image2"
                        style="margin-top:5px;margin-left:-15px"
                        top="照片2"
                        type="WorkOrderImage"
                        @imageChange="image2Change"
                        :count="1"
                        edit
                />
                <UploadImage
                        :imageList="image3"
                        style="margin-top:5px;margin-left:-15px"
                        top="照片3"
                        type="WorkOrderImage"
                        @imageChange="image3Change"
                        :count="1"
                        edit
                />
                <UploadImage
                        :imageList="image4"
                        style="margin-top:5px;margin-left:-15px"
                        top="照片4"
                        type="WorkOrderImage"
                        @imageChange="image4Change"
                        :count="1"
                        edit
                />
            </div>
            <Button type="info" block class="fixed-bottom-button" native-type="submit">确认提交</Button>
            <SelectDict dictKey="INSPECT_TSAK_DEVICE_HANDLE_METHOD" :show="selectShow"
                        @cancel="selectShow=false" @ok="onMethodOk"/>
        </Form>
    </div>
</template>

<script>
    import {Button, Cell, CellGroup, Dialog, Divider, Field, Form} from "vant"
    import SelectDict from "@/components/SelectPopup/SelectDict";
    import UploadImage from "@/components/UploadImage"
    import {mapGetters} from "vuex";
    import {downloadImg} from "@/config"

    export default {
        components: {Divider, Dialog, Cell, CellGroup, SelectDict, Button, Form, Field, UploadImage},
        props: {},
        data() {
            return {
                id: this.$route.params.id,
                detail: {
                    // id: this.$route.params.id,
                    handleMethod: [],
                    handleRemark: null,
                    handleImage1: null,
                    handleImage2: null,
                    handleImage3: null,
                    handleImage4: null,
                },
                handleMethodName: null,
                selectShow: false,
                device: {device: {}}
            }
        },
        computed: {
            productImage() {
                return downloadImg + this.device.productImage1
            },
            ...mapGetters({position: 'wechat/position'}),
            image1() {
                return this.detail.handleImage1 ? [this.detail.handleImage1] : []
            },
            image2() {
                return this.detail.handleImage2 ? [this.detail.handleImage2] : []
            },
            image3() {
                return this.detail.handleImage3 ? [this.detail.handleImage3] : []
            },
            image4() {
                return this.detail.handleImage4 ? [this.detail.handleImage4] : []
            },
        },
        created() {
        },
        mounted() {
            this.getInspectDevice()
        },
        methods: {
            getInspectDevice() {
                this.$http.tokiot.inspectTask.inspectDeviceDetail({id: this.id})
                    .then(res => {
                        if (res) {
                            this.device = res
                        }
                    })
            },
            submit() {
                this.detail.id = this.id;
                this.detail.handleLng = this.position.longitude;
                this.detail.handleLat = this.position.latitude;
                this.$toast.loading("正在处理中...")
                this.$http.tokiot.inspectTask.submit(this.detail)
                    .then(res => {
                        if (res) {
                            this.$toast.success("处理成功")
                            setTimeout(() => {
                                this.$router.history.go(-1);
                            }, 500);
                        } else {
                            this.$toast.fail(res.message)
                        }
                    })
            },
            image1Change(imageList) {
                this.detail.handleImage1 = imageList[0];
            },
            image2Change(imageList) {
                this.detail.handleImage2 = imageList[0];
            },
            image3Change(imageList) {
                this.detail.handleImage3 = imageList[0];
            },
            image4Change(imageList) {
                this.detail.handleImage4 = imageList[0];
            },
            updateShow() {
                this.selectShow = true;
            },
            onMethodOk(data) {
                this.handleMethodName = data.codeName;
                this.detail.handleMethod = data.code;
                this.selectShow = false;
            },
        },
        watch: {}
    }
</script>

<style lang="less" scoped>
    .fixed-bottom-button {
        position: fixed;
        margin-left: 8px;
        bottom: 8px;
        width: calc(100% - 16px);
    }

    .content {
        width: 100%;
        & > .center {
            padding: 12px 18px;
            display: flex;
            & > img {
                width: 65px;
                height: 65px;
                background: #cccccc;
               // border-radius: 8px;
            }
            & > .name {
                padding-left: 20px;
                height: 100%;
                display: flex;
                flex-direction: column;
                & > div {
                    line-height: 1.8;
                }
            }
        }
    }

</style>